export const CUSTOMER_PO_MAX_LENGTH = 50;
export const STOP_NUMBER_MAX_LENGTH = 50;
export const SHIPPER_RECEIVER_NAME_MAX_LENGTH = 50;
// 100 is the width of the downstream Tender table column
// (tblTraxTenderALoadStopData.StopAddress). The Quote table column is wider
// (250), but this page always tenders, so the narrower limit applies.
export const STREET_ADDRESS_MAX_LENGTH = 100;
export const APPOINTMENT_INFORMATION_MAX_LENGTH = 200;
// 100 is the width of the downstream Tender table column
// (tblTraxTenderALoadData.Commodity). The Quote table column is wider (255),
// but this page always tenders, so the narrower limit applies.
export const COMMODITY_MAX_LENGTH = 100;
export const SPECIAL_LOAD_INSTRUCTIONS_MAX_LENGTH = 200;

export function customerPoValidator(value: string): string {
	if (!value?.trim()) {
		return "Customer PO is required.";
	}
	if (value.length > CUSTOMER_PO_MAX_LENGTH) {
		return `Customer PO cannot exceed ${CUSTOMER_PO_MAX_LENGTH} characters.`;
	}
	return "";
}

export function stopNumberValidator(
	value: string | undefined,
	label: string,
): string {
	if (value && value.length > STOP_NUMBER_MAX_LENGTH) {
		return `${label} cannot exceed ${STOP_NUMBER_MAX_LENGTH} characters.`;
	}
	return "";
}

export function shipperNameValidator(
	value: string | undefined,
	label: string,
): string {
	if (!value) {
		return `${label} is required.`;
	}
	if (value.length > SHIPPER_RECEIVER_NAME_MAX_LENGTH) {
		return `${label} cannot exceed ${SHIPPER_RECEIVER_NAME_MAX_LENGTH} characters.`;
	}
	return "";
}

export function streetAddressValidator(value: string | undefined): string {
	if (!value) {
		return "Street Address is required.";
	}
	if (value.length > STREET_ADDRESS_MAX_LENGTH) {
		return `Street Address cannot exceed ${STREET_ADDRESS_MAX_LENGTH} characters.`;
	}
	return "";
}

export function appointmentInformationValidator(
	value: string | undefined,
): string {
	if (value && value.length > APPOINTMENT_INFORMATION_MAX_LENGTH) {
		return `Appointment Information cannot exceed ${APPOINTMENT_INFORMATION_MAX_LENGTH} characters.`;
	}
	return "";
}

export function trailerTypeValidator(value: string): string {
	if (!value) {
		return "Trailer Type is required.";
	}
	return "";
}

export function trailerSizeValidator(value: string): string {
	if (!value) {
		return "Trailer Size is required.";
	}
	return "";
}

export function loadValueValidator(value: string): string {
	if (!value) {
		return "Load Value is required.";
	}
	return "";
}

export function commodityValidator(value: string): string {
	if (!value) {
		return "Commodity is required.";
	}
	if (value.length > COMMODITY_MAX_LENGTH) {
		return `Commodity Description cannot exceed ${COMMODITY_MAX_LENGTH} characters.`;
	}
	return "";
}

export function specialLoadInstructionsValidator(
	value: string | undefined,
): string {
	if (value && value.length > SPECIAL_LOAD_INSTRUCTIONS_MAX_LENGTH) {
		return `Special Load Instructions cannot exceed ${SPECIAL_LOAD_INSTRUCTIONS_MAX_LENGTH} characters.`;
	}
	return "";
}

export function weightValidator(value: number): string {
	if (value == undefined || value == null) {
		return "Total Weight is required.";
	}
	if (value <= 0) {
		return "Total Weight must be greater than zero.";
	}
	return "";
}

export function temperatureValidator(value: string): string {
	if (value == undefined || value == null || value === "") {
		return "Temperature is required.";
	}
	return "";
}
